"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var SortAscending = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M16,20 L4,20 C3.44771525,20 3,19.5522847 3,19 L3,17 L16,17 L16,20 Z M4,19 L15,19 L15,18 L4,18 L4,19 Z M13,16 L3,16 L3,13 L13,13 L13,16 Z M4,15 L12,15 L12,14 L4,14 L4,15 Z M10,12 L3,12 L3,9 L10,9 L10,12 Z M4,11 L9,11 L9,10 L4,10 L4,11 Z M7,8 L3,8 L3,6 C3,5.44771525 3.44771525,5 4,5 L7,5 L7,8 Z M4,7 L6,7 L6,6 L4,6 L4,7 Z M19,6.70710678 L19,20 L18,20 L18,6.70710678 L15.8799429,8.8484282 C15.6866246,9.0436855 15.3716219,9.04525737 15.1763646,8.85193907 C14.9791508,8.6547341 14.978619,8.33800511 15.1734155,8.14189592 L18.5,4.79289322 L21.8634684,8.14374614 C22.0587298,8.33827523 22.0593235,8.6542629 21.8647944,8.84952435 C21.6687108,9.04560922 21.3520067,9.0460502 21.1560421,8.85117395 L19,6.70710678 Z" })));
};
SortAscending.displayName = 'SortAscending';
exports.default = SortAscending;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=SortAscending.js.map